import _ from 'lodash'

import routeParams from 'helpers/routeParams'
import { get } from 'lodash'

const GET_TASKS_AWARD_SIGNOFF =
  'dofe-bo/awardSignoffTasks/GET_TASKS_AWARD_SIGNOFF'
const GET_TASKS_AWARD_SIGNOFF_SUCCESS =
  'dofe-bo/awardSignoffTasks/GET_TASKS_AWARD_SIGNOFF_SUCCESS'
const GET_TASKS_AWARD_SIGNOFF_FAIL =
  'dofe-bo/awardSignoffTasks/GET_TASKS_AWARD_SIGNOFF_FAIL'
const GET_TASKS_AWARD_OFFICE_SIGNOFF =
  'dofe-bo/awardSignoffTasks/GET_TASKS_AWARD_OFFICE_SIGNOFF'
const GET_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS =
  'dofe-bo/awardSignoffTasks/GET_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS'
const GET_TASKS_AWARD_OFFICE_SIGNOFF_FAIL =
  'dofe-bo/awardSignoffTasks/GET_TASKS_AWARD_OFFICE_SIGNOFF_FAIL'

const EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF =
  'dofe-bo/awardSignoffTasks/EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF'
const EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF_SUCCESS =
  'dofe-bo/awardSignoffTasks/EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF_SUCCESS'
const EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF_FAIL =
  'dofe-bo/awardSignoffTasks/EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF_FAIL'

const EXPORT_TASKS_AWARD_OFFICE_SIGNOFF =
  'dofe-bo/awardSignoffTasks/EXPORT_TASKS_AWARD_OFFICE_SIGNOFF'
const EXPORT_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS =
  'dofe-bo/awardSignoffTasks/EXPORT_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS'
const EXPORT_TASKS_AWARD_OFFICE_SIGNOFF_FAIL =
  'dofe-bo/awardSignoffTasks/EXPORT_TASKS_AWARD_OFFICE_SIGNOFF_FAIL'

const SET_SORT = 'dofe-bo/awardSignoffTasks/SET_SORT'
const SET_FILTER = 'dofe-bo/awardSignoffTasks/SET_FILTER'
const SET_OFFICE_FILTER = 'dofe-bo/awardSignoffTasks/SET_OFFICE_FILTER'
const SET_BASE_FILTER = 'dofe-bo/awardSignoffTasks/SET_BASE_FILTER'
const SET_LIMIT = 'dofe-bo/awardSignoffTasks/SET_LIMIT'
const SET_OFFSET = 'dofe-bo/awardSignoffTasks/SET_OFFSET'
const SET_DISABLED_CACHE = 'dofe-bo/awardSignoffTasks/SET_DISABLED_CACHE'
const RESET_TASKS_AWARD_OFFICE =
  'dofe-bo/awardSignoffTasks/RESET_TASKS_AWARD_OFFICE'
const REMOVE_DETAIL_DATA = 'dofe-bo/awardSignoffTasks/REMOVE_DETAIL_DATA'
const SET_OFFICE_PARAMS = 'dofe-bo/awardSignoffTasks/SET_OFFICE_PARAMS'
const SET_UNIT_PARAMS = 'dofe-bo/awardSignoffTasks/SET_UNIT_PARAMS'

// refactor root fields into au object
const initialState = {
  unit: {
    list: [],
    detail: {},
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    invalidate: null,
    loading: false,
    loaded: false
  },
  office: {
    list: [],
    detail: {},
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    invalidate: null,
    loading: false,
    loaded: false
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_AWARD_SIGNOFF:
      return {
        ...state,
        unit: {
          ...state.unit,
          loading: true
        }
      }
    case GET_TASKS_AWARD_SIGNOFF_SUCCESS:
      return {
        ...state,
        unit: {
          ...state.unit,
          loading: false,
          loaded: true,
          list: action.result,
          count: action.headers['x-total-count'],
          pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.unit.limit
          ) || state.unit.pages
        }
      }
    case GET_TASKS_AWARD_SIGNOFF_FAIL:
      return {
        ...state,
        unit: {
          ...state.unit,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case GET_TASKS_AWARD_OFFICE_SIGNOFF:
      return {
        ...state,
        ...state,
        office: {
          ...state.office,
          loading: true
        }
      }
    case GET_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS:
      return {
        ...state,
        office: {
          ...state.office,
          loading: false,
          loaded: true,
          list: action.result,
          count: action.headers['x-total-count'],
          pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.office.limit
          ) || state.office.pages
        }
      }
    case GET_TASKS_AWARD_OFFICE_SIGNOFF_FAIL:
      return {
        ...state,
        office: {
          ...state.office,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case SET_SORT:
      return Object.assign({}, state, {
        unit: {
          ...state.unit,
          sort: action.sortBy
        }
      })
    case SET_FILTER:
      return Object.assign({}, state, {
        unit: {
          ...state.unit,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      })
    case SET_OFFICE_FILTER:
      return Object.assign({}, state, {
        office: {
          ...state.office,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      })
    case SET_BASE_FILTER:
      return Object.assign({}, state, {
        unit: {
          ...state.unit,
          baseFilter: action.filterBy,
          invalidate: new Date().getTime()
        }
      })
    case SET_LIMIT:
      return Object.assign({}, state, {
        unit: {
          ...state.unit,
          limit: action.limit
        }
      })
    case SET_OFFSET:
      return Object.assign({}, state, {
        unit: {
          ...state.unit,
          offset: action.offset
        }
      })
    case SET_DISABLED_CACHE:
      return Object.assign({}, state, {
        loaded: false
      })
    case REMOVE_DETAIL_DATA:
      return Object.assign({}, state, {
        detail: {}
      })
    case SET_OFFICE_PARAMS:
      return {
        ...state,
        office: {
          ...state.office,
          limit: action.options.limit !== undefined
            ? action.options.limit
            : state.office.limit,
          offset: action.options.offset !== undefined
            ? action.options.offset
            : state.office.offset,
          filter: action.options.filter !== undefined
            ? action.options.filter
            : state.office.filter,
          sort: action.options.sort !== undefined
            ? action.options.sort
            : state.office.sort,
          invalidate: _.isEmpty(action.options)
            ? state.office.invalidate
            : new Date().getTime()
        }
      }
    case SET_UNIT_PARAMS:
      return {
        ...state,
        unit: {
          ...state.unit,
          limit: action.options.limit !== undefined
            ? action.options.limit
            : state.unit.limit,
          offset: action.options.offset !== undefined
            ? action.options.offset
            : state.unit.offset,
          filter: action.options.filter !== undefined
            ? action.options.filter
            : state.unit.filter,
          sort: action.options.sort !== undefined
            ? action.options.sort
            : state.unit.sort,
          invalidate: _.isEmpty(action.options)
            ? state.unit.invalidate
            : new Date().getTime()
        }
      }
    case RESET_TASKS_AWARD_OFFICE:
      return {
        ...state,
        office: initialState.office
      }
    default:
      return state
  }
}

export function getTasksAwardSignoff({ filter = null, limit, offset, sort }) {
  const query = filter ? `&filter=${filter}` : ''
  const firstRow = (offset && `&firstRow=${offset}`) || ''
  const maxRows = (limit && `&maxRows=${limit}`) || ''
  const getTotalRowCount = '&getTotalRowCount=true'
  const sortQuery = (sort && `&sort=${sort}`) || ''

  return {
    types: [
      GET_TASKS_AWARD_SIGNOFF,
      GET_TASKS_AWARD_SIGNOFF_SUCCESS,
      GET_TASKS_AWARD_SIGNOFF_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-signoff?with=PARTICIPANT_PERSON,AWARD,ACTIVITY_WITH_PROGRESS${query}${maxRows}${firstRow}${getTotalRowCount}${sortQuery}`
      )
  }
}

export function getTasksAwardOfficeSignoff(params = {}, baseFilter) {
  const officeParams = get(params, 'office')

  return {
    types: [
      GET_TASKS_AWARD_OFFICE_SIGNOFF,
      GET_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS,
      GET_TASKS_AWARD_OFFICE_SIGNOFF_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-office-signoff?with=APPEND_RESTRICTION,AWARD_WITH_PARTICIPANT,PREVIOUS_COMPLETED_AWARD_LEVEL,ORGANIZATION,LABELS,ORGANIZATION_HIERARCHY${routeParams(officeParams ? officeParams : params, baseFilter)}`
      )
  }
}

export function exportAwardOfficeTasks(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_TASKS_AWARD_OFFICE_SIGNOFF,
      EXPORT_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS,
      EXPORT_TASKS_AWARD_OFFICE_SIGNOFF_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-office-signoff?with=AWARD_WITH_PARTICIPANT,ORGANIZATION${routeParams({ filter: params.filter }, baseFilter)}`
      )
  }
}

export function getTasksAwardOfficeSignoffLocally(params = {}, baseFilter) {
  return {
    types: [
      GET_TASKS_AWARD_OFFICE_SIGNOFF,
      GET_TASKS_AWARD_OFFICE_SIGNOFF_SUCCESS,
      GET_TASKS_AWARD_OFFICE_SIGNOFF_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-office-signoff-locally?with=ORGANIZATION,LABELS,PREVIOUS_COMPLETED_AWARD_LEVEL,AWARD_WITH_PARTICIPANT${routeParams(params, baseFilter)}`
      )
  }
}

export function exportAwardOfficeLocallyTasks(params = {}, baseFilter) {
  return {
    types: [
      EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF,
      EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF_SUCCESS,
      EXPORT_TASKS_AWARD_LOCALLY_OFFICE_SIGNOFF_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/award-office-signoff-locally?with=ORGANIZATION,PREVIOUS_COMPLETED_AWARD_LEVEL,AWARD_WITH_PARTICIPANT${routeParams({ filter: params.filter }, baseFilter)}`
      )
  }
}

export function setAwardSignoffSort(sortBy) {
  return {
    type: SET_SORT,
    sortBy
  }
}

export function setAwardSignoffFilter(filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function setAwardOfficeSignoffFilter(filterBy) {
  return {
    type: SET_OFFICE_FILTER,
    filterBy
  }
}

export function setAwardSignoffBaseFilter(filterBy) {
  return {
    type: SET_BASE_FILTER,
    filterBy
  }
}

export function setAwardSignoffLimit(limit) {
  return {
    type: SET_LIMIT,
    limit
  }
}

export function setAwardSignoffOffset(offset) {
  return {
    type: SET_OFFSET,
    offset
  }
}

export function removeDetailData() {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeCache() {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function resetTasksAwardOffice() {
  return {
    type: RESET_TASKS_AWARD_OFFICE
  }
}

export function setUnitParams(options) {
  return {
    type: SET_UNIT_PARAMS,
    options
  }
}

export function setOfficeParams(options) {
  return {
    type: SET_OFFICE_PARAMS,
    options
  }
}
